var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/nodes/accordeon.ts
import "@adornis/buildify/client/components/x-buildify-permission-selection";
import "@adornis/buildify/client/components/x-icon-button";
import { ModeConsumer, SizeConsumer } from "@adornis/buildify/client/globals/consumer.js";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-hr";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/fonts/fonts";
import "@adornis/forms/x-input";
import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { NodeSelection } from "prosemirror-state";
import { filter } from "rxjs";
import "../../db/HTMLBaseAccordeon.js";
import {
  ACCORDEON_CONTAINER_KEY,
  ACCORDEON_CONTAINER_SCHEMA,
  ACCORDEON_CONTENT_KEY,
  ACCORDEON_CONTENT_SCHEMA,
  ACCORDEON_KEY,
  ACCORDEON_SCHEMA,
  ACCORDEON_TITLE_KEY,
  ACCORDEON_TITLE_SCHEMA
} from "../../schema/nodes/accordeon.js";
import { BuildifyLitElement } from "../BuildifyLitElement.js";
import { runInsertNode } from "../helper/runInsertNode.js";
import { MenuItemGroup } from "../types.js";
import { isNodeSelection } from "../util.js";
var editor = ({ contentController, controllerBaseKeyPath }) => {
  return html`
    <x-flex space="md">
      <x-infobox>
        Wenn ein bestimmtes Accordeon bereits beim Öffnen der Seite offen visualisiert werden soll, kannst du hier die
        Nummer des betroffenen Accordeons angeben.
      </x-infobox>
      <x-input
        placeholder="Geöffnet"
        type="number"
        ${contentController.field(...controllerBaseKeyPath, "openIndex")}
      ></x-input>
      <x-buildify-spacing-picker
        clearable
        placeholder="Abstand zwischen den Accordeons"
        select
        ${contentController.field(...controllerBaseKeyPath, "spaceBetweenItems")}
      ></x-buildify-spacing-picker>
    </x-flex>
  `;
};
var accordeonContainer = () => ({
  node: {
    name: ACCORDEON_CONTAINER_KEY,
    schema: ACCORDEON_CONTAINER_SCHEMA()
  },
  menuItems: [
    {
      group: MenuItemGroup.LAYOUT,
      label: "Accordeon",
      icon: "keyboard_arrow_down",
      run: (view) => runInsertNode(ACCORDEON_CONTAINER_KEY, (state2) => {
        return {
          content: [
            state2.schema.nodes[ACCORDEON_KEY].create({}, [
              state2.schema.nodes[ACCORDEON_TITLE_KEY].create({}, [
                state2.schema.nodes.paragraph.create({}, [state2.schema.text("Titel")])
              ]),
              state2.schema.nodes[ACCORDEON_CONTENT_KEY].create({}, [
                state2.schema.nodes.paragraph.create({}, [state2.schema.text("Content")])
              ])
            ])
          ]
        };
      })(view.state, view),
      shouldVisualize: (view) => {
        return !isNodeSelection(view.state.selection);
      }
    }
  ],
  editor
});
var accordeon = () => ({
  node: {
    name: ACCORDEON_KEY,
    schema: ACCORDEON_SCHEMA()
  },
  menuItems: [
    {
      label: "Accordeon hinzuf\xFCgen",
      icon: "add",
      run: (view) => addAccordion()(view.state, view.dispatch),
      shouldVisualize: (view) => {
        return isNodeSelection(view.state.selection) && view.state.selection.node.type.name === ACCORDEON_CONTAINER_KEY;
      }
    }
  ]
});
var accordeonTitle = () => ({
  node: {
    name: ACCORDEON_TITLE_KEY,
    schema: ACCORDEON_TITLE_SCHEMA()
  }
});
var accordeonContent = () => ({
  node: {
    name: ACCORDEON_CONTENT_KEY,
    schema: ACCORDEON_CONTENT_SCHEMA()
  }
});
var accordeonConfigs = () => [accordeonContainer(), accordeon(), accordeonTitle(), accordeonContent()];
function addAccordion() {
  return (state2, dispatch) => {
    const containerNodeType = state2.schema.nodes[ACCORDEON_CONTAINER_KEY];
    const accordionNodeType = state2.schema.nodes[ACCORDEON_KEY];
    if (!containerNodeType || !accordionNodeType)
      return false;
    const { selection } = state2;
    if (!(selection instanceof NodeSelection))
      return false;
    const node = selection.node;
    let insertFrom = selection.from;
    for (const child of node.children) {
      insertFrom += child.nodeSize;
    }
    const accordionNode = state2.schema.nodes[ACCORDEON_KEY].create({}, [
      state2.schema.nodes[ACCORDEON_TITLE_KEY].create({}, [
        state2.schema.nodes.paragraph.create({}, [state2.schema.text("Titel")])
      ]),
      state2.schema.nodes[ACCORDEON_CONTENT_KEY].create({}, [
        state2.schema.nodes.paragraph.create({}, [state2.schema.text("Content")])
      ])
    ]);
    const tr = state2.tr.insert(insertFrom, accordionNode);
    if (dispatch) {
      dispatch(tr);
    }
    return true;
  };
}
var NodeAccordeonContainer = class extends BuildifyLitElement {
  updated(changedProperties) {
    super.updated(changedProperties);
    const slot = this.renderRoot.querySelector("slot");
    if (!slot)
      return;
    for (const [index, element] of slot.assignedElements().entries()) {
      if (!(element instanceof NodeAccordeon))
        continue;
      if (index === this._openIndex || this._isPrint())
        element.isOpen = true;
      else
        element.isOpen = false;
    }
  }
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    this._data.observable.pipe(filter(Boolean)).subscribe((data) => {
      if (typeof data.openIndex !== "number")
        return;
      this._openIndex = data.openIndex - 1;
    });
    this.addEventListener("toggle-open", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const index = e.detail.value;
      if (index === this._openIndex)
        this._openIndex = void 0;
      else
        this._openIndex = index;
    });
    this.addEventListener("open", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const index = e.detail.value;
      this._openIndex = index;
    });
  }
  content({ content, mode }) {
    return html`
      <x-flex ${css({ gap: content.spaceBetweenItems ?? "0" })}>
        <slot></slot>
      </x-flex>
    `;
  }
};
__decorateClass([
  state()
], NodeAccordeonContainer.prototype, "_openIndex", 2);
NodeAccordeonContainer = __decorateClass([
  customElement("node-accordeon-container")
], NodeAccordeonContainer);
var NodeAccordeon = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.isOpen = false;
    this._consumedMode = ModeConsumer(this);
    this._consumedSize = SizeConsumer(this);
  }
  getAccordeonIndex() {
    const parent = this.parentElement;
    if (parent) {
      const children = Array.from(parent.children);
      return children.indexOf(this);
    }
    return -1;
  }
  open() {
    this.dispatchEvent(
      new CustomEvent("open", { detail: { value: this.getAccordeonIndex() }, composed: true, bubbles: true })
    );
  }
  render() {
    const isEditor = this._consumedMode.value === "edit";
    const handleClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const index = this.getAccordeonIndex();
      this.dispatchEvent(new CustomEvent("toggle-open", { detail: { value: index }, composed: true, bubbles: true }));
    };
    return html`
      <x-flex
        horizontal
        crossaxis-center
        space="sm"
        ${css({ cursor: isEditor ? "" : "pointer" })}
        @click=${(e) => {
      if (isEditor)
        return;
      handleClick(e);
    }}
      >
        <x-icon
          @click=${(e) => {
      if (!isEditor)
        return;
      handleClick(e);
    }}
          ${css({ fontSize: "20px", cursor: isEditor ? "pointer" : "", color: this.colors.accent })}
        >
          ${this.isOpen ? "keyboard_arrow_down" : "keyboard_arrow_right"}
        </x-icon>
        <slot name="accordeon-title"></slot>
      </x-flex>
      <slot
        ${css({
      display: this.isOpen ? "block" : "none",
      padding: "4px",
      margin: this._consumedSize.value === "mobile" ? "" : "0 24px"
    })}
        name="accordeon-content"
      ></slot>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          userSelect: "none",
          display: "block"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], NodeAccordeon.prototype, "isOpen", 2);
NodeAccordeon = __decorateClass([
  customElement("node-accordeon")
], NodeAccordeon);
export {
  NodeAccordeon,
  NodeAccordeonContainer,
  accordeon,
  accordeonConfigs,
  accordeonContainer,
  accordeonContent,
  accordeonTitle,
  addAccordion
};
